class TagsFilter extends HTMLElement {
    constructor() {
      super();
      this.tagButtons = null;
      this.allTopicsButton = null;
    }
  
    connectedCallback() {
      this.initialize();
    }
  
    initialize() {
      this.tagButtons = this.querySelectorAll("[data-blog-tag]");
      this.allTopicsButton = this.querySelector("[data-blog-tag='all']");
  
      this.setupEventListeners();
      this.setInitialActiveState();
    }
  
    setupEventListeners() {
      this.tagButtons.forEach((button) => {
        button.addEventListener("click", () => this.handleTagClick(button));
      });
    }
  
    handleTagClick(button) {
      const selectedTag = button.getAttribute("data-blog-tag");
      const currentTags = this.getCurrentTagsFromURL();
      const baseURL = this.getBaseURL();

      if (selectedTag === "all" || (currentTags.length === 1 && currentTags[0] === selectedTag)) {
        this.updateURL(baseURL);
      } else {
        this.updateURL(`${baseURL}/tagged/${selectedTag}`);
      }
    }
  
    getCurrentTagsFromURL() {
      const path = window.location.pathname;
      return path.includes("/tagged/") ? path.split("/tagged/")[1].split("+") : [];
    }
  
    getBaseURL() {
      const currentPath = window.location.pathname;
      const basePath = currentPath.split('/tagged')[0];
      return window.location.origin + basePath;
    }
    
    updateURL(newPath) {
      window.location.href = newPath;
    }
  
    setInitialActiveState() {
      const currentTags = this.getCurrentTagsFromURL();
      const activeTag = currentTags.length ? currentTags[0] : null;

      if (activeTag) {
        this.tagButtons.forEach((button) => {
          if (button.getAttribute("data-blog-tag") === activeTag) {
            button.classList.add("tag-active");
          }
        });
      } else {
        this.allTopicsButton.classList.add("tag-active");
      }
    }
}
  
window.customElements.define("tags-filter", TagsFilter);  



class BlogSearch extends HTMLElement {
  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    const searchInput = this.querySelector("#blogSearchInput");
    searchInput.addEventListener("input", () => this.searchBlogPosts());
  }

  searchBlogPosts() {
    const input = this.querySelector("#blogSearchInput");
    const resultList = this.querySelector("#search-results-list");
    const blogList = this.querySelector("#blog-list");
    const grid = this.querySelector("#blog-posts-grid");
    const items = grid.getElementsByClassName("blog-post-item");

    if (!input.value.trim()) {
      resultList.style.display = "none";
      blogList.style.display = "block";
      return;
    }

    const filter = input.value.toUpperCase();
    resultList.style.display = "block";
    blogList.style.display = "none";

    Array.from(items).forEach((item) => {
      const title = item.querySelector("h3");
      const txtValue = title?.textContent || title?.innerText || "";
      item.style.display = txtValue.toUpperCase().includes(filter) ? "" : "none";
    });
  }
}

window.customElements.define("blog-search", BlogSearch);